import makeStyles from '@mui/styles/makeStyles';

export const usePageStyles = makeStyles(theme => ({
  wrapper: {
    width: '100%',
    aspectRatio: '16/9',
    border: `${theme.palette.baseColors.black.c12} 0.125rem solid`,
    cursor: 'pointer',
    transition: 'border 0.32s var(--ease-enter)',
    '&:hover': {
      borderColor: theme.palette.baseColors.infoBlue.c75,
      transition: 'border 0.32s var(--ease-exit)',
    },
  },
  selected: {
    border: `2px solid ${theme.palette.baseColors.infoBlue.c100}`,
  },
  pageItem: {
    display: 'grid',
    alignItems: 'center',
    gridTemplateColumns: '1.5rem 1fr',
    marginBottom: '1rem',
    position: 'relative',
    scrollSnapAlign: 'start',

    '&:hover $deleteIcon': {
      opacity: 1,
      transition: 'opacity 0.2s var(--ease-enter)',
    },
  },
  pagePreview: {
    transform: 'scale(0.2)',
    transformOrigin: 'top left',
    width: '500%',
    height: '500%',
    pointerEvents: 'none',
  },
  staticOverlay: {
    position: 'absolute',
    inset: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    pointerEvents: 'none',
  },
  pageNumber: {
    minWidth: '1.5rem',
    fontSize: '1rem',
    fontFamily: 'Barlow',
  },
  deleteIcon: {
    position: 'absolute',
    top: '-0.5rem',
    right: '-0.5rem',
    backgroundColor: `${theme.palette.baseColors.white.c100}`,
    color: theme.palette.baseColors.errorRed.c100,
    border: `0.125rem solid ${theme.palette.baseColors.errorRed.c100}`,
    borderRadius: '50%',
    padding: '0.125rem',
    cursor: 'pointer',
    opacity: 0,
    transition: 'opacity 0.2s var(--ease-exit)',
  },
  newPageButton: {
    width: '100%',
    aspectRatio: '16/9',
    border: `0.125rem dashed ${theme.palette.baseColors.infoBlue.c100}`,
    backgroundColor: `${theme.palette.baseColors.white.c100}`,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    overflow: 'hidden',
    transition: 'border-color 0.4s var(--ease-exit)',
    gridColumnStart: '2',

    '&::before': {
      content: '""',
      position: 'absolute',
      inset: 0,
      backgroundImage: `repeating-linear-gradient(
        135deg,
        ${theme.palette.baseColors.infoBlue.c100} 0,
        ${theme.palette.baseColors.infoBlue.c100} 0.0625rem,
        transparent 0.25rem,
        transparent 0.5rem
      )`,
      opacity: 0,
      transition: 'opacity 0.32s var(--ease-enter)',
    },

    '&:hover': {
      borderStyle: 'solid',
      '&::before': {
        opacity: 1,
      },
    },

    '&:hover $addIcon': {
      backgroundColor: theme.palette.baseColors.infoBlue.c100,
      boxShadow: `0 0 0 0.5rem ${theme.palette.baseColors.infoBlue.c100}40`,
      color: `${theme.palette.baseColors.white.c100}`,
    },
  },
  addIcon: {
    fontSize: '3rem',
    borderRadius: '50%',
    position: 'relative',
    zIndex: 1,
    color: theme.palette.baseColors.infoBlue.c100,
  },
  scrollContainer: {
    height: '100%',
    overflowY: 'auto',
    padding: '1rem 1rem 3rem 0',
    scrollSnapType: 'y proximity',
    scrollBehavior: 'smooth',
    scrollPadding: '1rem',
  },
}));
